module.exports = __webpack_public_path__ + "static/media/Feedback_PDF@2x.61b0adce.png";